import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link } from 'react-router-dom';
import moment from 'moment-timezone'
import * as actions from "../redux/actions";

export class NotificationItem extends Component {
    constructor(props) {
        super(props);
        this.state= {
            isAcknowledged: this.props.isAcknowledged
        }
        this.markAsRead = this.markAsRead.bind(this)
        this.handleClickSwitch = this.handleClickSwitch.bind(this)
    }

    markAsRead(item) {
        
        this.setState({
            isAcknowledged: true            
        })

        this.props.onItemClick(item.notificationIds)
    }

    handleClickSwitch(item) {
        
        if(this.props.actions.triggerClickSwitch) {
            this.props.actions.triggerClickSwitch();
        }
    }
    
    componentWillReceiveProps(nextProps) {
        if(this.state.isAcknowledged !== nextProps.isAcknowledged) {
            
            this.setState({
                isAcknowledged: nextProps.isAcknowledged
            })
        }
    }

    render() {
        let { item } = this.props;
        let cssClass = this.state.isAcknowledged ? 'notification-item acknowledged' : 'notification-item'
        let notificationLink = "";

        //set the link out for supervisor
        if(item.isSupervisor === true) {

           notificationLink = { 
                pathname: '/TimeOff/Pending', 
                managementUnitID: item.managementUnitID
            };
        }
        else { //set the link out for agent
            notificationLink = item.route === 'TimeOff'? '/' + item.route : `/Schedules/` + moment(item.scheduleStartDate).format('YYYY-MM-DD');
        }

        return(
            <div className={cssClass} onClick={(ids) => this.markAsRead(item)}>
                <span className="notification-border"></span>
                <span className="notification-item-text">{item.text}</span>
                <span className="notification-item-text">
                    {item.description + " "}
                    <Link to={notificationLink} onClick={(ids) => this.handleClickSwitch(item)}>{ item.link }</Link>
                </span>
                {
                    item.isSupervisor === false ?
                    (<span className="notification-item-text date-created">                    
                        {item.dateCreated}
                    </span>)
                    :
                    ""
                }
            </div>
        )
    }
}

function mapStateToProps(state) {
	return {
        notifications: state.common.notifications,
    };
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({ ...actions }, dispatch)
	};
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(NotificationItem);


// WEBPACK FOOTER //
// ./src/features/common/Notifications/NotificationItem.js